import React, { useRef, useState, useEffect, useCallback } from 'react';
import Swiper from 'swiper';
import { Button } from '../ui/Button';
import { tabSliderContent } from './TabSlider.content';
import arrow from '../HalfSlider/assets/arrow.svg';
import styles from './TabSlider.module.sass';
import 'swiper/dist/css/swiper.min.css';

export function TabSlider() {
  const { slides } = tabSliderContent;
  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    swiperRef.current = new Swiper(containerRef.current, {
      slidesPerView: 1,
      speed: 700,
      loop: true,
      // autoplay: {
      //   delay: 3000,
      //   disableOnInteraction: false,
      // },
      on: {
        slideChange() {
          setActiveIndex(this.realIndex);
        },
      },
    });

    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true);
        swiperRef.current = null;
      }
    };
  }, []);

  const handleTabClick = useCallback((index) => {
    if (swiperRef.current) {
      swiperRef.current.slideToLoop(index);
    }
  }, []);

  const handlePrev = useCallback(() => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  }, []);

  const handleNext = useCallback(() => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  }, []);

  const currentSlide = slides[activeIndex];

  return (
    <section className={styles.tabSlider}>
      <div className={styles.tabSlider__tabs}>
        {slides.map((slide, i) => (
          <Button
            key={i}
            label={slide.tab}
            variant={i === activeIndex ? 'simple' : 'glass'}
            onClick={() => handleTabClick(i)}
          />
        ))}
      </div>

      <div className={`swiper-container ${styles.tabSlider__swiper}`} ref={containerRef}>
        <div className="swiper-wrapper">
          {slides.map((slide, i) => (
            <div key={i} className="swiper-slide">
              <img src={slide.image} alt="" className={styles.tabSlider__image} />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.tabSlider__overlay}>
        <h3 className={styles.tabSlider__title}>{currentSlide.title}</h3>
        <p className={styles.tabSlider__subtitle}>
          <span className={styles.tabSlider__subtitleAccent}>
            {currentSlide.subtitleAccent.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < currentSlide.subtitleAccent.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </span>{' '}
          {currentSlide.subtitle}
        </p>
        <div className={styles.tabSlider__nav}>
          <button
            className={styles.tabSlider__navBtn}
            onClick={handlePrev}
            aria-label="Предыдущий слайд"
          >
            <img src={arrow} alt="" className={styles.tabSlider__navIcon} />
          </button>
          <button
            className={styles.tabSlider__navBtn}
            onClick={handleNext}
            aria-label="Следующий слайд"
          >
            <img
              src={arrow}
              alt=""
              className={`${styles.tabSlider__navIcon} ${styles.tabSlider__navIconRight}`}
            />
          </button>
        </div>
        <p className={styles.tabSlider__desc}>
          <span className={styles.tabSlider__descAccent}>{currentSlide.descAccent}</span>{' '}
          {currentSlide.desc}
        </p>
      </div>
    </section>
  );
}
